module.exports = PropTypes;


//////////////////
// WEBPACK FOOTER
// external "PropTypes"
// module id = 1
// module chunks = 0